@if (opStart()) {
	@if (rollen().length >= 2) {
		<app-rol-switcher [rollen]="rollen()" [activeRol]="activeRol()" (rolChange)="changeRol($event)"></app-rol-switcher>
	}
} @else {
	<app-breadcrumb></app-breadcrumb>
}

<div class="acties">
	<app-button buttonType="text" [autoHeight]="true" #feedbackButton (clickit)="openFeedback()">Feedback</app-button>
	<app-button buttonType="text" [autoHeight]="true" (clickit)="openHelp()">Help</app-button>
	<app-profiel-menu></app-profiel-menu>
</div>
